import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Registration.css";

// Components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {
  setRcityTown,
  setRcountry,
  setREmail,
  setRfirstName,
  setRisEighteen,
  setRlastName,
  setRpassword,
  setRphone,
  setRprovince,
  setRsex,
  setRstreet,
  setRzipCode,
} from "../../features/registration/registrationSlice";
import { countryList } from "./country";
import { cityObj, provinceObj } from "./province";
function Registration() {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [value, setValue] = React.useState(moment());
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [fname, setFname] = React.useState("");
  const [lname, setLname] = React.useState("");
  const [sex, setSex] = React.useState("");
  const [phone, setPhone] = React.useState("+63");
  const [city, setCity] = React.useState("");
  const [province, setProvince] = React.useState("");
  const [street, setStreet] = React.useState("");
  const [postal, setPostal] = React.useState("");
  const [filterCity, setFilterCity] = React.useState(cityObj);
  const [country, setCountry] = React.useState("");
  const [eighteen, setIsEighteen] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleCountryOnChange = (e) => {
    setCountry(e.target.value);
  };
  const handleProvinceChange = (event) => {
    setProvince(event.target.value);
    var value = event.target.value;
    const filteredProv = provinceObj.filter((prov) => prov.name === value);
    const filteredCityObj = cityObj.filter(
      (prov) => prov.province === filteredProv[0].key
    );

    setFilterCity(filteredCityObj);
  };

  const handleNextPage = (event) => {
    event.preventDefault();
    // todo: make api endpoint for user registration
    event.preventDefault();
    // todo: make api endpoint for user registration
    if (
      email === "" ||
      email === undefined ||
      password === "" ||
      password === undefined ||
      confirmPassword === "" ||
      confirmPassword === undefined ||
      fname === "" ||
      fname === undefined ||
      lname === "" ||
      lname === undefined ||
      sex === "" ||
      sex === undefined ||
      phone === "" ||
      phone === undefined ||
      postal === "" ||
      postal === undefined ||
      value === undefined
    ) {
      return Swal.fire({
        icon: "error",
        title: "Some fields are empty",
        text: "Please fill all required fields",
      });
    }
    if (
      (city === "" || city === undefined) &&
      (province === "" || province === undefined) &&
      (street === "" || street === undefined)
    ) {
      return Swal.fire({
        icon: "error",
        title: "Some fields are empty",
        text: "Please fill all required fields",
      });
    }
    if (confirmPassword !== password) {
      return Swal.fire({
        icon: "error",
        title: "Passwords do not match",
        text: "Please try again",
      });
    }
    if (phone.length < 10) {
      return Swal.fire({
        icon: "error",
        title: "Error! Please enter a valid mobile number",
        text: "",
      });
    }

    if (password.length < 6) {
      return Swal.fire({
        icon: "error",
        title: "Password too weak",
        text: "Must be atleast 6 characters",
      });
    }

    if (!eighteen) {
      return Swal.fire({
        icon: "error",
        title: "Age Requirement",
        text: "You must be atleast 18 years old and above",
      });
    }
    // console.log(email);

    dispatch(setRfirstName(fname));
    dispatch(setREmail(email));
    dispatch(setRcityTown(city));
    dispatch(setRlastName(lname));
    dispatch(setRpassword(password));
    dispatch(setRprovince(province));
    dispatch(setRsex(sex));
    dispatch(setRstreet(street));
    dispatch(setRzipCode(postal));
    dispatch(setRphone(phone));
    dispatch(setRcountry(country));
    dispatch(setRisEighteen(eighteen));
    navigate("/registrationPg2");
  };

  const handleChangeDropdown = (event) => {
    setSex(event.target.value);
  };

  if (isLoggedIn) {
    navigate("/");
  }

  return (
    <>
      <Grid container spacing={2} direction="row" justifyContent="center">
        <Grid item xs="auto" sx={{ marginLeft: "5rem" }}>
          <Box className="card card--left">
            <Box className="card">
              <Box>
                <h1 className="card__title">Welcome to Tuos</h1>
              </Box>
              <Box>
                <Box mt="1.5em" />
                <p className="card__text">
                  In order to proceed with the platform, we would to get to know
                  you better.
                </p>
                <Box mt="1.5em" />
                <p className="card__text">This will only take 1 - 2mins.</p>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs="auto">
          <Box className="card card--right">
            <Box
              className="card"
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
            >
              <h2 className="textfield__text">Login Details</h2>
              <TextField
                className="textfield textfield__fullwidth"
                required
                id="outlined-required"
                label="Email"
                type="email"
                fullWidth
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                className="textfield"
                required
                id="outlined-required"
                label="Password"
                type="password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <TextField
                className="textfield"
                required
                id="outlined-required"
                label="Confirm Password"
                type="password"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <h2 className="textfield__text">Personal Details</h2>
              <TextField
                className="textfield"
                required
                id="outlined-required"
                label="First Name"
                onChange={(e) => setFname(e.target.value)}
              />
              <TextField
                className="textfield"
                required
                id="outlined-required"
                label="Last Name"
                onChange={(e) => setLname(e.target.value)}
              />
              {/* <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  className="textfield"
                  label="BirthDate"
                  inputFormat="MM/DD/YYYY"
                  value={value}
                  onChange={handleChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider> */}
              <FormControl
                style={{
                  minWidth: "13.3rem",
                  marginTop: "0.5rem",
                  marginLeft: "0.6rem",
                }}
              >
                <InputLabel id="test-select-label">Sex</InputLabel>
                <Select
                  className="textfield"
                  required
                  labelId="test-select-label"
                  id="demo-simple-select"
                  value={sex}
                  label="Sex"
                  onChange={handleChangeDropdown}
                >
                  <MenuItem value={"male"}>Male</MenuItem>
                  <MenuItem value={"female"}>Female</MenuItem>
                  <MenuItem value={"rather not say"}>Rather not say</MenuItem>
                </Select>
              </FormControl>
              <TextField
                className="textfield"
                required
                id="outlined-required"
                label="Phone Number"
                inputProps={{ maxLength: 13 }}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <Grid container mt={2} ml={0.1} spacing={1}>
                <Grid md={1}>
                  <Checkbox
                    value={eighteen}
                    onChange={(e) => {
                      setIsEighteen(!eighteen);
                    }}
                  />
                </Grid>
                <Grid md={8}>
                  <Typography
                    color="text.secondary"
                    fontSize={15}
                    variant="h6"
                    mt={1}
                  >
                    I am atleast 18 years old
                  </Typography>
                </Grid>
              </Grid>

              <h2 className="textfield__text">Address</h2>
              {/* Country */}
              <TextField
                select
                name="country"
                onChange={(event) => handleCountryOnChange(event)}
                // disable autocomplete
                maxRows={3}
                inputProps={{
                  autocomplete: "new-password",
                  form: {
                    autocomplete: "off",
                  },
                  style: {
                    fontSize: 15,
                    paddingTop: 10,
                  },
                }}
                className="textfield textfield__fullwidth"
                label="Country"
              >
                {countryList.map((val) => {
                  return <MenuItem value={val}>{val}</MenuItem>;
                })}
              </TextField>
              {/* province */}
              {country === "Philippines" ? (
                <TextField
                  select
                  name="province"
                  onChange={(event) => handleProvinceChange(event)}
                  // disable autocomplete
                  maxRows={3}
                  inputProps={{
                    autocomplete: "new-password",
                    form: {
                      autocomplete: "off",
                    },
                    style: {
                      fontSize: 15,
                      paddingTop: 10,
                    },
                  }}
                  className="textfield"
                  label="Province"
                >
                  {provinceObj.map((provObj, index) => {
                    return (
                      <MenuItem value={provObj.name}>{provObj.name}</MenuItem>
                    );
                  })}
                </TextField>
              ) : (
                <></>
              )}
              {/* City town */}
              {country === "Philippines" ? (
                <TextField
                  required
                  select
                  name="cityTown"
                  onChange={(e) => setCity(e.target.value)}
                  // disable autocomplete
                  inputProps={{
                    autocomplete: "new-password",
                    form: {
                      autocomplete: "off",
                    },
                    style: {
                      fontSize: 15,
                      paddingTop: 10,
                    },
                  }}
                  className="textfield"
                  label="City/Town"
                >
                  {filterCity.map((ciObj, index) => {
                    return <MenuItem value={ciObj.name}>{ciObj.name}</MenuItem>;
                  })}
                </TextField>
              ) : (
                <></>
              )}
              {country !== "Philippines" && country !== "" ? (
                <TextField
                  className="textfield textfield__fullwidth"
                  required
                  id="outlined-required"
                  label="Address"
                  onChange={(e) => setStreet(e.target.value)}
                />
              ) : (
                <></>
              )}
              <TextField
                className="textfield"
                required
                id="outlined-required"
                label="Zip Code"
                inputProps={{ maxLength: 4 }}
                onChange={(e) => setPostal(e.target.value)}
              />
              <Button
                variant="contained"
                className="registration__button"
                onClick={handleNextPage}
              >
                Continue
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default Registration;
